import { computed } from "mobx";
import { useCallback, useMemo } from "react";
import { useAuthStore } from "..";

const useGetLeadColor = (): (status: string) => string => {
    const authStore = useAuthStore();
    const colorSchema = useMemo(() => computed(() => authStore.user!.companyColorSchemeSettings.leadsStatusDisplaySettings), []).get();

    return useCallback((status: string): string =>
        colorSchema.find(s => s.leadStatus == status)?.displayColor || "#707070", [colorSchema]);
};

export default useGetLeadColor;